import { SwipeAction } from "antd-mobile"
import styled from "styled-components"

export const StyledSwipeAction = styled(SwipeAction)`
  --adm-color-danger: #ff4921;
  cursor: default;
  overflow: hidden;
  background-color: transparent;

  .adm-swipe-action-actions-right .adm-button {
    width: 64px;
    min-width: 64px;
    margin-left: 8px;
  }

  span {
    display: flex;
  }
`

export const IngredientItemContent = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 0px;
  gap: var(--spacing_xl, 24px);
`

export const IngredientLeft = styled.div`
  display: flex;
  gap: 8px;
  flex-grow: 1;
  max-width: calc(100% - 32px - 24px);
`

export const IngredientInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: calc(100% - 40px - 8px - 32px - 24px);
  flex-grow: 1;
  cursor: default;
  gap: 4px;
`

export const IngredientName = styled.p`
  font-size: 14px;
  color: var(--Schemes-On-Surface, #1c1f21);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 17px;
`

export const IngredientBottomInfo = styled.div`
  height: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
`

export const IngredientUnitAndPortionBox = styled.div`
  display: flex;
  align-items: center;
  color: var(--Schemes-Surface-On-surface-On-Surface-Variant-2, #69757d);
`

export const IngredientNutrient = styled.div`
  color: var(--Schemes-On-Surface-Variant, #69757d);
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.12px;
  flex-shrink: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`

export const IngredientBrand = styled.div`
  border-radius: 2px;
  background: var(--Schemes-Surface-Container, #ebedf0);
  display: flex;
  padding: 1px 4px 0px 4px;
  align-items: center;
  height: 15px;

  p {
    font-weight: 500;
    font-size: 12px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #69757d;
    margin: 0;
  }
`
